import { ASH_MEDIA } from "@/game/media";

/**
 * AshLogo
 * - variant="icon"  → square phoenix mark (good for badges, HUD, small spots)
 * - variant="full"  → horizontal "ASH interactive" lockup (good for branding moments)
 *
 * Set `size` for icon variant (square px). For full variant, use `width` (auto height).
 */
export default function AshLogo({
  variant = "icon",
  size = 56,
  width = 220,
  className = "",
  alt = "ASH Interactive",
  ...rest
}) {
  if (variant === "full") {
    return (
      <img
        src={ASH_MEDIA.ash_logo_full}
        alt={alt}
        style={{ width, height: "auto" }}
        className={`ash-logo-full ${className}`}
        data-testid="ash-logo-full"
        {...rest}
      />
    );
  }
  return (
    <img
      src={ASH_MEDIA.ash_logo_icon}
      alt={alt}
      width={size}
      height={size}
      className={`ash-logo-icon ${className}`}
      data-testid="ash-logo"
      {...rest}
    />
  );
}
